import React from 'react';
import {useRecommendedParticipantsFilter} from '../../../../../data/hooks/participant/useRecommendedParticipantsFilter';
import {useI18n} from '../../../../../data/hooks/i18nHooks';
import styles from './ActiveSuggestionsInfo.module.scss';
import { isSuggestedParticipantsTabSelected } from '../ParticipantsTabs/SuggestedParticipants/isSuggestedParticipantsTabSelected';

function ActiveSuggestionsInfo(props) {
    const {eventId, filterParams} = props,
        suggestedFilterParams = useRecommendedParticipantsFilter(eventId),
        i18n = useI18n();

    if (!isSuggestedParticipantsTabSelected(filterParams, suggestedFilterParams)) return null;

    return <div className={styles.ActiveSuggestionsInfo}>{i18n['hint.tab.recommended_info']}</div>;
}

export default ActiveSuggestionsInfo;
